import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { TestHooks } from './create-fire-insurance-company.hooks';
import { FireInsuranceCompany } from '@models/brokerage';

@Component({
	selector: 'app-create-fire-insurance-company',
	templateUrl: './create-fire-insurance-company.component.html',
	standalone: false,
})
export class CreateFireInsuranceCompanyComponent {
	testHooks = TestHooks;
	@Input() name;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	@Output() onCancel = new EventEmitter();
	@Output() onCreate = new EventEmitter();

	constructor(private matterDispatch: MatterDispatch) {}

	_onSubmit(fireInsuranceCompany: FireInsuranceCompany) {
		this.matterDispatch.CreateFireInsuranceCompany(
			this.matterId,
			fireInsuranceCompany,
		);
		this.onCreate.emit();
	}

	_onCancel() {
		this.onCancel.emit();
	}
}
